import { spawn, call, put, takeLatest } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';
import { newsActions } from '../../../application/actions/news';

import api from '../../api/index';

const apiRequest = api(process.env.REACT_APP_HOST);


export function* findNews(e) {
    console.log("findNews")
    yield put(newsActions.newsConexion({conexion:true}));
    try {
        const  params  = e.payload;
        const optionalsHeaders = {
            'Content-Type': 'application/json; charset=utf-8',
            'Access-Control-Allow-Origin': '*'
        }
        const url = `news/news.php`
        const response = yield call(
            apiRequest.post,
            url,
            params,
            optionalsHeaders
        );

        const { data, nota, result } = response;;
        yield put(newsActions.newsCreate({ data, nota, result }));
    } catch (err) {
        yield put(newsActions.newsConexion({conexion:false}));
        yield put(newsActions.newsError({error:err.message}));
    } finally {
    }
}

export function* watchFetchSesion() {
    yield takeLatest(NewsActionsSaga.findNewsService.type, findNews);
}

export default function* rootSaga() {
    yield spawn(watchFetchSesion);
}


const findNewsService = createAction('lateSaga/findNewsService');

export const NewsActionsSaga = {
    findNewsService,
};
